import { createReducer } from '@reduxjs/toolkit'
import { fetchTutorialsRoutine } from './actions'
import { tutorialsInitialState } from './state'

const tutorialsReducer = createReducer(tutorialsInitialState, builder => {
  builder
    .addCase(fetchTutorialsRoutine.TRIGGER, state => {
      state.loading = true
      state.error = null
    })
    .addCase(fetchTutorialsRoutine.SUCCESS, (state, action) => {
      state.loading = false
      state.items = action.payload
      state.lastFetchedAt = Date.now()
    })
    .addCase(fetchTutorialsRoutine.FAILURE, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
})

export default tutorialsReducer
